export default function HapticIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#231F20">
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M44 34c0 5.523-4.478 10-10 10s-10-4.477-10-10 4.478-10 10-10 10 4.477 10 10M34 66v2c18.777 0 34-15.222 34-34h-2c0 17.645-14.355 32-32 32M34 2V0C15.222 0 0 15.222 0 34h2C2 16.355 16.355 2 34 2"
                    transform="translate(-605 -2418) translate(506 2398) translate(83 20) translate(16) translate(6 6)"
                  />
                  <path
                    d="M34 8V6C18.536 6 6 18.536 6 34h2C8 19.664 19.664 8 34 8M34 60v2c15.464 0 28-12.536 28-28h-2c0 14.336-11.663 26-26 26"
                    transform="translate(-605 -2418) translate(506 2398) translate(83 20) translate(16) translate(6 6)"
                  />
                  <path
                    d="M34 14v-2c-12.15 0-22 9.85-22 22h2c0-11.028 8.972-20 20-20M34 54v2c12.15 0 22-9.85 22-22h-2c0 11.028-8.972 20-20 20"
                    transform="translate(-605 -2418) translate(506 2398) translate(83 20) translate(16) translate(6 6)"
                  />
                  <path
                    d="M34 48v2c8.837 0 16-7.164 16-16h-2c0 7.72-6.28 14-14 14M34 50v-2c-7.72 0-14-6.28-14-14h-2c0 8.836 7.163 16 16 16M34 20v-2c-8.837 0-16 7.164-16 16h2c0-7.72 6.28-14 14-14M48 34h2c0-8.836-7.163-16-16-16v2c7.72 0 14 6.28 14 14"
                    transform="translate(-605 -2418) translate(506 2398) translate(83 20) translate(16) translate(6 6)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
